import React from 'react';
import StyledSpinner from '../styles/StyledSpinner';

function Spinner() {
  return <StyledSpinner />;
}

export default Spinner;
